// extracted by mini-css-extract-plugin
export default {"container":"Footnote--container--VuBbX","icon":"Footnote--icon--c9koR","row":"Footnote--row--n++7O"};